import { render, staticRenderFns } from "./OrganizationFilter.vue?vue&type=template&id=d661b2bc"
import script from "./OrganizationFilter.vue?vue&type=script&lang=js"
export * from "./OrganizationFilter.vue?vue&type=script&lang=js"
import style0 from "./OrganizationFilter.vue?vue&type=style&index=0&id=d661b2bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports